import React from 'react';
import './index.css';

export function Card(props) {
  return (
    <div 
      style={props.style}
      className={`ui-card ${props.className || ""}`}>
      {props.children}
    </div>
  );
}